import React from 'react';

interface ITabContentProps {
  title: string;
  value: string;
  component: React.ReactNode;
}
export default function TabContent({ title, value, component }: ITabContentProps) {
  if (title === value) {
    return <>{component}</>;
  } else {
    return <></>;
  }
}
